var map = {
	"./CoffeeAppPic.png": 1530,
	"./CoffeeAppPic_Mobile.png": 1216,
	"./HHH_Homepage.png": 5410,
	"./HHH_Homepage_Mobile.png": 7805,
	"./Projects": 9523,
	"./Projects.css": 2307,
	"./Projects.js": 9523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5805;